import React from 'react';

const binding = field => field?.moduleBinding || {};
const kind = field => field?.academicKind || (binding(field).moduleField === 'classId' ? 'class' : ['education.courseId', 'education.groupId', 'courseId', 'groupId'].includes(binding(field).moduleField) ? 'course' : '');
const moduleKey = field => field?.academicModule || binding(field).moduleKey;
export { kind as integratedAcademicKind, moduleKey as integratedAcademicModule };
export const isIntegratedAcademicField = field => Array.isArray(field?.academicOptions) && Boolean(kind(field));
export default function IntegratedAcademicSelect({ field, fields = [], values = {}, onChange, disabled = false, ...props }) {
  const sameModule = other => moduleKey(other) === moduleKey(field);
  const parent = kind(field) === 'class' ? fields.find(other => sameModule(other) && kind(other) === 'course') : null;
  const parentId = kind(field) === 'class' ? (field.academicParentFieldId || parent?.id) : null;
  const parentValue = parentId ? String(values[parentId] ?? '') : '';
  const options = (field.academicOptions || []).filter(option => !parentId || String(option.parentId) === parentValue);
  const waiting = Boolean(parentId && !parentValue);
  const change = event => {
    const value = event.target.value;
    const patch = { [field.id]: value };
    if (kind(field) === 'course') {
      fields.filter(other => sameModule(other) && kind(other) === 'class').forEach(other => {
        const current = String(values[other.id] ?? '');
        if (current && !(other.academicOptions || []).some(option => String(option.value) === current && String(option.parentId) === value)) patch[other.id] = '';
      });
    }
    onChange(patch);
  };
  return <select {...props} id={props.id || field.id} name={field.id} value={values[field.id] ?? ''} required={field.required && !disabled} disabled={disabled || waiting} onChange={change}>
    <option value="">{waiting ? 'Selecione o curso primeiro' : options.length ? 'Selecione...' : 'Nenhuma turma disponível'}</option>
    {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
  </select>;
}
